import React from "react";

type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    to: string;
    /** If true, opens in a new tab (sets target and rel defaults). */
    newTab?: boolean;
};

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    ({ to, newTab = false, target, rel, children, ...rest }, ref) => {
        const finalTarget = newTab ? target ?? "_blank" : target;
        const finalRel = newTab ? rel ?? "noopener noreferrer" : rel;
        return (
            <a
                href={to}
                target={finalTarget}
                rel={finalRel}
                ref={ref}
                {...rest}
            >
                {children}
            </a>
        );
    }
);